import { Injectable } from "@angular/core";
import { PlessJsonDownloadService } from 'src/app/shared/http/pless-json-download.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessDialogService } from 'src/app/shared/pless-dialog-service';
import { HttpClient } from '@angular/common/http';
import { KYMW1002Model } from '../kymw1002.model';

/**
 * 処理ログファイルをダウンロードするサービスクラス
 *
 * @export DownloadResultLogService
 * @class DownloadResultLogService
 * @extends {PlessResponder}
 */
@Injectable()
export class DownloadResultLogService extends PlessJsonDownloadService {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof DownloadResultLogService
   */
  private codeValue: string = "";

  constructor(
    protected http: HttpClient,
    protected dialogService: PlessDialogService
  ) {
    super(http, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {string} API用リクエストオブジェクト
   * @memberof DownloadResultLogService
   */
  private getBody(filePath:string): PlessRequest {
    return new PlessRequest({
      parameter: {
        filePath: filePath
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1002Model} model
   * @memberof DownloadResultLogService
   */
  execute(model: KYMW1002Model): void {
    const filePath = model.resultLogPath;
    const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
    this.send('downloadResultLog', this.getBody(filePath), fileName);
  }
}
